module.exports = __webpack_public_path__ + "img/AL-G.bb582eb0.jpg";